export type Bi = { fr: string; en: string }
export type TransformKey = 'analyze' | 'simplify' | 'connect' | 'automate' | 'orchestrate' | 'measure'

export const atnaTransformCopy = {
  eyebrow: { fr: 'INTÉGRER L’INTELLIGENCE AUX OPÉRATIONS', en: 'BUILDING INTELLIGENCE INTO OPERATIONS' },
  headline: [
    { text: { fr: 'Ne pas simplement', en: 'Don’t just' }, accent: false },
    { text: { fr: 'ajouter de l’IA.', en: 'add AI.' }, accent: false },
    { text: { fr: 'Repenser la façon', en: 'Rethink how' }, accent: true },
    { text: { fr: 'dont le travail progresse.', en: 'work moves forward.' }, accent: true },
  ],
  body: {
    fr: 'ATNA aide à analyser vos processus, à éliminer les étapes et systèmes redondants, à connecter les bonnes données et à intégrer l’intelligence directement dans vos opérations.',
    en: 'ATNA helps analyze your processes, remove redundant steps and systems, connect the right data and build intelligence directly into your operations.',
  },
  simplifyBefore: [
    { fr: 'Système A', en: 'System A' },
    { fr: 'Système B', en: 'System B' },
    { fr: 'Saisie manuelle', en: 'Manual entry' },
    { fr: 'Suivi manuel', en: 'Manual tracking' },
  ],
  simplifyAfter: { fr: 'Un flux simplifié', en: 'One streamlined flow' },
  control: [
    { fr: 'ATNA prépare et orchestre.', en: 'ATNA prepares and orchestrates.' },
    { fr: 'L’équipe garde le contrôle.', en: 'The team stays in control.' },
  ],
  outcome: [
    { text: { fr: 'Moins de complexité.', en: 'Less complexity.' }, accent: false },
    { text: { fr: 'Moins de travail manuel.', en: 'Less manual work.' }, accent: false },
    { text: { fr: 'Plus de capacité.', en: 'More capacity.' }, accent: true },
  ],
}

export const transformSteps: { key: TransformKey; label: Bi; desc: Bi }[] = [
  { key: 'analyze', label: { fr: 'Analyser', en: 'Analyze' }, desc: { fr: 'Comprendre le processus actuel', en: 'Understand the current process' } },
  { key: 'simplify', label: { fr: 'Simplifier', en: 'Simplify' }, desc: { fr: 'Retirer les étapes inutiles', en: 'Remove unnecessary steps' } },
  { key: 'connect', label: { fr: 'Connecter', en: 'Connect' }, desc: { fr: 'Relier données et systèmes', en: 'Link data and systems' } },
  { key: 'automate', label: { fr: 'Automatiser', en: 'Automate' }, desc: { fr: 'Confier les tâches appropriées à ATNA', en: 'Hand the right tasks to ATNA' } },
  { key: 'orchestrate', label: { fr: 'Orchestrer', en: 'Orchestrate' }, desc: { fr: 'Humains, agents et systèmes', en: 'People, agents and systems' } },
  { key: 'measure', label: { fr: 'Mesurer', en: 'Measure' }, desc: { fr: 'Capacité, délais et qualité', en: 'Capacity, time and quality' } },
]
